import { computed } from 'vue'

export function useWidthStyle(width) {
	const widthStyle = computed(() => {
		const obj: any = {}
		if (width) {
			if (!isNaN(Number(width))) {
				obj.width = width + 'em'
			} else if (width === 'full') {
				obj.width = '100%'
			} else {
				obj.width = width
			}
		}
		return obj
	})

	return {
		widthStyle,
	}
}
